import React from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Container from '../components/Container';
import SectionTitle from '../components/SectionTitle';
import ParseHTML from '../components/ParseHTML';

if (process.env.BROWSER) {
    require('flexboxgrid');
    var scrollToElement = require('scroll-to-element');
}

const AboutUs = React.createClass({
    propTypes: {
        title: React.PropTypes.string.isRequired,
        members: React.PropTypes.array
    },
    getInitialState: function() {
        return {
            openIndex: -1
        };
    },
    _openItem: function (item) {
        var clickedItem = ReactDOM.findDOMNode(this.refs['teamimage' + item]);
        scrollToElement(clickedItem, {
            ease: 'linear',
            duration: 600
        });
        this.setState({
            openIndex: (item == this.state.openIndex) ? -1 : item
        });
    },
    render: function() {
        return (
            <Container>
                <SectionTitle>{this.props.title}</SectionTitle>
                <div className="team-member-wrapper">
                    {this.props.members.map((item, index) => {
                        let styles = {
                            backgroundImage: "url(" + item.image + ")"
                        };
                        return (
                            <div className={item.detail ? "hasDetail team-member" : "team-member"}  ref={"teamimage" + index} onClick={item.detail ? this._openItem.bind(this, index) : null} key={index}>
                                <div className="team-member-image" style={styles} >
                                    <div className={`team-member-job ${(index == this.state.openIndex) ? "active" : ""}`}>
                                        <h4>{item.job}</h4>
                                        {(index == this.state.openIndex) ? (
                                            <div className="team-member-detail">
                                                <ParseHTML>
                                                    {item.detail}
                                                </ParseHTML>
                                            </div>
                                        ) : null}
                                        {item.detail ? (
                                            <div>
                                                <span className="more-icon" title="weitere Infos">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                                                        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"/>
                                                    </svg>
                                                </span>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <h3>{item.firstname} {item.lastname}</h3>
                            </div>
                        );
                    })}
                </div>
            </Container>
        );
    }
});

const mapStateToProps = (state) => {
    return {
        title: state.team.title,
        members: state.team.members
    };
};

export default connect(mapStateToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/js/containers/Team.js